	/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

//@module Account
define('LW.MultiPL.Model'
,	[	'Backbone'
	,	'underscore'
	,	'Utils'
	]
,	function (
		Backbone
	,	_
	,	Utils
	)
{
	'use strict';

	//@class Account.Register.Model
	// Sends user input data to the register service
	// validating fields before they are sent
	// [Backbone.validation](https://github.com/thedersen/backbone.validation)
	//@extend Backbone.Model
	return Backbone.Model.extend({

		urlRoot: _.getAbsoluteUrl(getExtensionAssetsPath('services/LW.MultiPL.Service.ss'))

	});
});
